import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/apiClient';

// Antes 6 hooks casi idénticos en profile/clientes/tasks/databases/docs/spaces pedían "todos los usuarios" con
// 6 queryKey distintas, sin compartir caché entre features — abrir Clientes y luego Tareas en
// la misma sesión disparaba un GET /api/users por cada una.
//
// `GET /api/users` (sin `all=true`) y `GET /api/users?all=true` NO son shapes de respuesta
// distintas (ambas devuelven un array plano) — son un FILTRO real: `all=true` incluye
// usuarios con role 'archivado', el default los excluye (ver
// `PgUserRepository.list()`). No es seguro unificar en una sola queryKey — un selector de
// asignación mostraría cuentas archivadas, o una pantalla de administración dejaría de verlas.
// Por eso son dos hooks (dos queryKey, cachean por separado), no uno solo con un parámetro.
export async function fetchAllUsers({ includeArchived = false } = {}) {
    const data = await apiClient.get(`/api/users${includeArchived ? '?all=true' : ''}`);
    return Array.isArray(data) ? data : [];
}

// El caso común: selectores de asignación/menciones/tablas — no tiene sentido ofrecer una
// cuenta archivada como asignable o mencionable.
export function useAllUsers() {
    return useQuery({ queryKey: ['users', 'all'], queryFn: () => fetchAllUsers() });
}

// Pantallas de administración (permisos de clientes, gestión de usuarios en Profile) que sí
// necesitan ver cuentas archivadas.
export function useAllUsersIncludingArchived() {
    return useQuery({
        queryKey: ['users', 'all', 'includingArchived'],
        queryFn: () => fetchAllUsers({ includeArchived: true }),
    });
}
